import {useCallback, useState} from 'react';

interface UseViewResult {
  visible: boolean;
  open: () => void;
  close: () => void;
}

export const useView = (): UseViewResult => {
  const [visible, setVisible] = useState(false);
  const open = useCallback(() => setVisible(true), []);
  const close = useCallback(() => setVisible(false), []);
  return {visible, open, close};
};
